import { ImportStoreType } from '@shared/types/store/import-store.types';
import { create } from 'zustand';

const defaultValues = {
  referenceId: '',
  progress: null,
};

export const useImportStore = create<ImportStoreType>((set) => ({
  ...defaultValues,
  setReferenceId: (referenceId) => set({ referenceId }),
  setProgres: (progress) => set({ progress }),
}));
